/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The method at which we process time logs for time quests
 * @export
 */
export const GuildQuestMode = {
    ALLTIME: 'ALLTIME',
    DIFF_DAYS: 'DIFF_DAYS',
    SINGLE_DAY: 'SINGLE_DAY'
} as const;
export type GuildQuestMode = typeof GuildQuestMode[keyof typeof GuildQuestMode];


export function instanceOfGuildQuestMode(value: any): boolean {
    for (const key in GuildQuestMode) {
        if (Object.prototype.hasOwnProperty.call(GuildQuestMode, key)) {
            if (GuildQuestMode[key as keyof typeof GuildQuestMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function GuildQuestModeFromJSON(json: any): GuildQuestMode {
    return GuildQuestModeFromJSONTyped(json, false);
}

export function GuildQuestModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): GuildQuestMode {
    return json as GuildQuestMode;
}

export function GuildQuestModeToJSON(value?: GuildQuestMode | null): any {
    return value as any;
}

export function GuildQuestModeToJSONTyped(value: any, ignoreDiscriminator: boolean): GuildQuestMode {
    return value as GuildQuestMode;
}

